export const SENDTOBANK = 'SENDTOBANK';
